<template>
  <MenuDisplay v-if="canUseVenueMenu" id="venue-menu" class="ml-4 relative">
    <template #trigger>
      <p
        class="text-base font-sans flex justify-start items-center gap-2 cursor-pointer text-fg-link-primary"
      >
        <span id="#venue-name-trigger">{{ venue_name }} </span>
        <ChevronDownIcon class="stroke-link-primary w-4 h-4" />
      </p>
    </template>
    <template #menu>
      <div
        class="absolute left-0 top-6 shadow bg-surface-primary rounded z-20 w-max py-1 overflow-y-auto tt-scroll max-h-[80vh]"
      >
        <a
          :href="'https://' + venue.primary_site + targetPath"
          v-for="venue in venues"
          :key="venue.primary_site"
          class="venue-link block cursor-pointer py-1 px-4 first:pt-2 last:pb-2 hover:bg-surface-base"
          :class="
            currentLocation.includes(venue.primary_site)
              ? 'text-fg-primary font-semibold'
              : 'text-fg-link-primary'
          "
        >
          {{ venue.name }}
        </a>
      </div>
    </template>
  </MenuDisplay>
  <p v-else id="single-venue-name" class="ml-4 text-base font-sans">
    {{ venue_name }}
  </p>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { PropType, defineComponent } from 'vue'

import ChevronDownIcon from '@/assets/chevronDown.svg?component'
import MenuDisplay from '@/common/components/atoms/MenuDisplay.vue'
import { useSettingStore } from '@/stores/setting'
import { useUserStore } from '@/stores/user'

import { UserVenueRead } from '@generated/types'

export default defineComponent({
  name: 'VenueSwitchMenu',
  props: {
    venues: {
      type: Array as PropType<UserVenueRead[]>,
      required: true,
    },
  },
  components: {
    ChevronDownIcon,
    MenuDisplay,
  },
  computed: {
    ...mapState(useSettingStore, ['venue_name']),
    currentLocation(): string {
      return window.location.origin
    },
    canUseVenueMenu(): boolean {
      if (this.venues.length > 1) return true
      else
        return (
          this.venues.length === 1 && !this.currentLocation.includes(this.venues[0].primary_site)
        )
    },
    targetPath(): string {
      if (useUserStore().isSuperuser) {
        return '/slogin/'
      } else {
        return '/venue/reservations/'
      }
    },
  },
})
</script>
